import React from "react";
import { withRouter } from "react-router-dom";
import toast from "react-hot-toast";

const PublicRoute = ({ component: Component, ...rest }) => {
  const publicRouteClass = () => {
    if (window.location.pathname === "/organizations/new") {
      return "content";
    } else {
      return "bg-login";
    }
  };
  return (
    <div className={publicRouteClass()}>
      <Component {...rest} toast={toast} />
    </div>
  );
};
export default withRouter(PublicRoute);
